import React from 'react';
import { Link } from 'react-router-dom';

import { useMicrosoft } from '../../_libs/hooks/useMicrosoft';
import { UserType } from '../../_libs/microsoft/types';

import MicrosoftSSOWidget from '../../molecules/MicrosoftSSOWidget';
import StandardPageTemplate from '../../templates/StandardPage';

const MicrosoftIndexPage = (
  { 
    type 
  } : {
    type: UserType;
  }
): JSX.Element => {
  const {
    isAuthenticated,
    isPublisher,
    error,
  } = useMicrosoft();

  // NOTE: When should publisher identity be identified? Or, how is the 'isPublisher' actually getting flagged?
  let content = <MicrosoftSSOWidget error={error} type={isPublisher ? 'publisher' : 'subscriber'} />;
  if (isAuthenticated) {
    if (isPublisher) {
      content =
        <div>
          <h1 className="f-serif f-normal f-italic">
            Identity verified.
          </h1>
          <Link className="button td-none" to="/microsoft/publisher/subscriptions">View All Subscriptions</Link>
        </div>;
    } else {
      content =
        <div>
          <h1 className="f-serif f-normal f-italic">
            Identity verified.
          </h1>
          <Link className="button td-none" to="/microsoft/subscriber/subscriptions">View Your Subscriptions</Link>
        </div>;
    }
  }

  return (
    <StandardPageTemplate>
      <div
        className="f-small f-serif"
        style={{
          textTransform: 'capitalize',
        }}>
          {type}
      </div>
      {content}
    </StandardPageTemplate>
  );
};

export default MicrosoftIndexPage;
